module.exports = __webpack_public_path__ + "img/myOffice.9e6fc5d6.png";